module.exports = __webpack_public_path__ + "img/boy question.2c4f5c7c.png";